<template>
  <div>
    <div
      id="SurveyContainer"
      class="card mobile-card"
      style="width:50%; left:25%; margin-top: 2%; margin-bottom: 10%;"
    >
      <!-- Exhibits -->
      <template v-if="!hasCompleted && exhibits.length !== 0">
        <br>
        <h4 class="text-center">
          Click On These For More Information
        </h4>
        <v-btn
          v-for="exhibit in exhibits"
          :key="exhibit.pk"
          :href="exhibit.file"
          target="_blank"
        >
          {{ exhibit.name }}
        </v-btn>
        <v-divider />
      </template>

      <!-- Map -->
      <Map
        v-if="!hasCompleted && mapType === `single`"
        :map-information="selectedSurvey.map_info"
      />
      <MultiPointMap
        v-if="!hasCompleted && mapType === `multi`"
        :map-information="selectedSurvey.map_info"
      />

      <!-- Extra Text -->
      <template v-if="!hasCompleted && selectedSurvey.extra_text">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <span v-html="selectedSurvey.extra_text" />
      </template>

      <!-- Survey -->
      <survey :survey="surveyJSObject" />

      <!-- Messages -->
      <span
        v-if="hasCompleted"
        class="text-center"
      >
        <h2 v-if="showSurveyError">
          {{ $t("message.surveyError") }}
        </h2>
        <h2 v-else>
          {{ $t("message.thanks") }}
        </h2>
        <StakeholderChoice
          v-if="shouldShowSurveySelect"
          @set-has-completed="setHasCompleted"
        />
        <span v-else>
          {{ $t("message.redirect") }}
        </span>
      </span>
    </div>
    <LanguageSelect />
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import Map from "@/components/Survey/Map";
import MultiPointMap from "@/components/Survey/MultiPointMap";
import LanguageSelect from "@/components/Utilities/LanguageSelect";
import * as SurveyVue from "survey-vue";
import * as widgets from "surveyjs-widgets";
import showdown from "showdown";
let Survey = SurveyVue.Survey;

Survey.cssType = "bootstrap";
widgets.prettycheckbox(SurveyVue);
widgets.bootstrapslider(SurveyVue);
widgets.sortablejs(SurveyVue);

export default {
  name: "PreviewSurveys",
  components: {
    Survey,
    Map,
    MultiPointMap,
    LanguageSelect
  },
  data() {
    return {
      hasCompleted: false,
      selectedSurvey: {},
      mapType: "none",
      surveyJSObject: new SurveyVue.Model({}),
    }
  },
  computed: {
    ...mapState({
      surveys: state => state.survey.surveys,
      exhibits: state => state.exhibits.surveyExhibits,
      coordinatesWithType: state => state.response.coordinatesWithType,
      coordinatesNoType: state => state.response.coordinates
    }),
  },
  watch: {
    "$i18n.locale"() {
      this.surveyJSObject.locale = this.$i18n.locale === "en" ? "default" : this.$i18n.locale;
    }
  },
  created(){
    this.setSelectedSurvey();
    this.getSurveyExhibits(this.selectedSurvey);
    this.setSurveyJS();
  },
  methods: {
    ...mapActions("exhibits", ["getSurveyExhibits"]),
    setSurveyJS() {
      const survey = this.checkMobileViewport(this.selectedSurvey.survey_json)
      let model = new SurveyVue.Model(survey);
      const converter = new showdown.Converter();
      model.onComplete.add(() => {
        this.submit_response();
      });
      model.getAllQuestions().forEach(q => {
        if (q.getType() === "sortablelist") {
          q.emptyText = "<b> &nbsp; &nbsp; Move the options below to reflect the order of importance </b>"
        }
        if (q.getType() === "bootstrapslider") {
          q.value = (q.rangeMax + q.rangeMin) / 2
        }
      });

      model.onValueChanging.add(function(survey, options) {
        survey.getAllQuestions().forEach(q => {
          if (q.getType() === "sortablelist" && q.name === options.name) {
            if (options.oldValue !== options.value) {
              q.resultEl.el.childNodes.forEach((node, index) => {
                if (index > 0) {
                  const choice = q.choices.find(choice => {
                    return choice.value === node.dataset.value
                  })
                  node.innerHTML = `<div class="sjs-sortablejs-item" style="background-color:#1ab394;color:#fff;margin:5px;padding:10px;">${index}. ${choice.text}</div>`;
                  node.outerHTML = `<div data-value="${node.dataset.value}"><div class="sjs-sortablejs-item" style="background-color:#1ab394;color:#fff;margin:5px;padding:10px;">${index}. ${choice.text}</div></div>`;
                }
              })
              q.sourceEl.el.childNodes.forEach(node => {
                const choice = q.choices.find(choice => {
                  return choice.value === node.dataset.value
                })
                node.innerHTML = `<div class="sjs-sortablejs-item" style="background-color:#1ab394;color:#fff;margin:5px;padding:10px;">${choice.text}</div>`;
                node.outerHTML = `<div data-value="${node.dataset.value}"><div class="sjs-sortablejs-item" style="background-color:#1ab394;color:#fff;margin:5px;padding:10px;">${choice.text}</div></div>`;
              })
            }
          }
        })
      })

      // There use to be a method that would check for questions that were like "Please choose 3 values"
      // and the logic used to be handled here, but can be handled in validations property inside the
      // actual survey, please check Campbellton Corridor Transit Project survey for example.

      model.onTextMarkdown.add(function(model, options) {
        //  convert the mardown text to html
        var str = converter.makeHtml(options.text);
        //  remove root paragraphs <p></p>
        str = str.substring(3);
        str = str.substring(0, str.length - 4);
        //  set html
        options.html = str;
      });

      model.locale = this.$i18n.locale === "en" ? "default" : this.$i18n.locale;
      model.showCompletedPage = false;
      model.clearInvisibleValues = "none";
      model.onUpdateQuestionCssClasses.add(function(survey, options) {
        var classes = options.cssClasses;
        classes.mainRoot += ` ${options.question.name}`
        classes.root = `sq-root sq-root-${options.question.getType()}`;
        classes.title = "sq-title";
        classes.item = "sq-item";
        classes.label = "sq-label";

        if (options.question.isRequired) {
          classes.title = "sq-title sq-title-required";
          classes.root = `sq-root sq-root-${options.question.getType()} sq-root-required sq-name-${options.question.name}`;
        }
      });
      model.showQuestionNumbers = "off";
      this.surveyJSObject = model
    },
    setSelectedSurvey() {
      let programName = this.$router.currentRoute.params.program_name.replace(/_/g, " ");
      let projectName = this.$router.currentRoute.params.project_name.replace(/_/g, " ");
      let surveyName = this.$router.currentRoute.params.survey_name.replace(/_/g, " ");
      let currentSurvey = this.surveys.find(survey => {
        if (survey.survey_metadata.meta_data.dashboardFiltering.program === programName &&
          survey.survey_metadata.meta_data.dashboardFiltering.project === projectName &&
          survey.survey_metadata.meta_data.dashboardFiltering.survey === surveyName) {
          return survey;
        }
      });
      this.mapType = currentSurvey.map_type;
      this.selectedSurvey = currentSurvey;
    },
    checkMobileViewport(survey) {
      if (this.$vuetify.breakpoint.xs) {
        const questionList = survey["pages"][0]["elements"]
        survey["pages"][0]["elements"] = questionList.map(question => {
          question["colCount"] = 1
          return question
        })
      }
      return survey
    },
  }
}
</script>

<style scoped>
@media (min-width: 360px) and (max-width: 1024px) {
  .gdotlogo {
    position: relative;
    float: center;
    left: auto !important;
    top: auto !important;
    width: auto;
  }
  .mobile-card {
    width: 80% !important;
    left: 10% !important;
  }
}

body {
  font-size: 3vw;
}
</style>
